import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { storesContext } from "./stores/useStores";
import RootStore from './stores/RootStore';
import { autorun } from "mobx";
import { loadState, saveState } from "./utils/localStorage";
import { HelmetProvider } from 'react-helmet-async';

import "rc-notification/assets/index.css";
import "react-perfect-scrollbar/dist/css/styles.css";
import 'react-loading-skeleton/dist/skeleton.css';
import 'react-medium-image-zoom/dist/styles.css';

import {
  BrowserRouter as Router
} from "react-router-dom";

const initState = loadState();

const mobxStore = new RootStore(initState);
autorun(
  () => {
    saveState(mobxStore.serialize());
  },
  { delay: 1000 }
);

ReactDOM.render(
  <React.StrictMode>
    <HelmetProvider>
      <storesContext.Provider value={mobxStore}>
        <Router>
          <App/>
        </Router>
      </storesContext.Provider>
    </HelmetProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
